module.exports = __webpack_public_path__ + "static/media/samsung-logo.9ad1bea5.png";